import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope  } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, Link } from 'react-router-dom';
import './footer.css';

const Footer = () => {
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();

    const handleNavigate = (path) => {
        navigate(path);
    };

    return (
        <footer className="footer-section">
            <div className="footer-top">
                <Container>
                    <Row className="align-items-center">
                        <Col lg={5} md={12} className="mb-5 mb-lg-0">
                            <div className="footer-about">
                                <div className="footer-logo">
                                    <h2>Thi<span className="highlight">nail</span></h2>
                                </div>
                                <p className="about-text">
                                    Chúng tôi cam kết giúp bạn vượt qua kỳ thi chứng chỉ nail một cách dễ dàng.
                                    Nền tảng của chúng tôi cung cấp các bài kiểm tra thực hành toàn diện, mẹo học tập,
                                    và cộng đồng hỗ trợ để hướng dẫn bạn trên mọi bước đi.
                                </p>
                                <div className="social-links">
                                    <a 
                                        href="https://www.facebook.com/people/Thi-Nail/61569172920677/" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="social-link"
                                    >
                                        <FontAwesomeIcon icon={faFacebook} />
                                    </a>
                                    <a 
                                        href="mailto:suport.thinail@gmail.com" 
                                        className="social-link"
                                    >
                                        <FontAwesomeIcon icon={faEnvelope} />
                                    </a>
                                </div>
                            </div>
                        </Col>
                        
                        <Col lg={3} md={6} sm={6} className="mb-4 mb-md-0 align-items-center">
                            <div className="footer-links">
                                <h3 className="footer-title">Liên kết</h3>
                                <ul className="links-list">
                                    <li>
                                        <Link to="/">Trang chủ</Link>
                                    </li>
                                    <li>
                                        <Link to="/about">Giới thiệu</Link>
                                    </li>
                                    <li>
                                        <Link to="/quizzes">Đề thi</Link>
                                    </li>
                                    <li>
                                        <Link to="/exam">Thi thử</Link>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                        
                        <Col lg={4} md={6} sm={6}>
                            <div className="footer-contact">
                                <h3 className="footer-title">Liên hệ</h3>
                                <ul className="contact-list">
                                    <li>
                                        <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                                        <a href="mailto:suport.thinail@gmail.com">suport.thinail@gmail.com</a>
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faFacebook} className="contact-icon" />
                                        <a 
                                            href="https://www.facebook.com/people/Thi-Nail/61569172920677/" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                        >
                                            Thi Nail
                                        </a>
                                    </li>
                                </ul>
                                <div className="support-message">
                                    <p>Chúng tôi luôn sẵn sàng hỗ trợ bạn</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            
            <div className="footer-bottom">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6} className="text-center text-md-start">
                            <p className="copyright">
                                &copy; {currentYear} Thinail. Tất cả các quyền được bảo lưu.
                            </p>
                        </Col>
                        <Col md={6} className="text-center text-md-end">
                            <div className="footer-bottom-links">
                                <Link to="/">thinail.com</Link>
                                <span className="separator">|</span>
                                <span 
                                    className="terms-link"
                                    onClick={() => handleNavigate('/terms-of-service')}
                                >
                                    Điều Khoản Dịch vụ
                                </span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </footer>
    );
};

export default Footer;